import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=2dcffcec&scoped=true&"
import script from "./billing.vue?vue&type=script&lang=js&"
export * from "./billing.vue?vue&type=script&lang=js&"
import style0 from "./billing.vue?vue&type=style&index=0&id=2dcffcec&scoped=true&lang=scss&"
import style1 from "./billing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcffcec",
  null
  
)

export default component.exports